export const NOT_FOUND = `404/`;
